import { SxProps, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const cardHeaderStyles: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: YodaSpacing.large,
};

export const cardHeaderTitleStyles: SxProps = {
  fontSize: YodaFontSize.xLarge,
  fontWeight: YodaFontWeight.medium,
  color: YodaColors.textPrimary,
};

export const cardContentStyles: SxProps = {
  borderTop: `1px solid ${YodaColors.gray1}`,
  paddingX: YodaSpacing.large,
  paddingBottom: YodaSpacing.large,
};

export const tableStyles: SxProps = {
  '& .MuiTableCell-root': {
    borderBottom: `1px solid ${YodaColors.gray1}`,
    padding: `${YodaSpacing.medium}px ${YodaSpacing.large}px`,
    verticalAlign: 'middle',
  },
  '& .MuiTableCell-root:first-of-type': {
    paddingLeft: 0,
  },
  '& .MuiTableCell-root:last-of-type': {
    paddingRight: 0,
  },
};

export const headerCellStyles: SxProps = {
  fontSize: YodaFontSize.xSmall,
  fontWeight: YodaFontWeight.medium,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
};

export const reminderNameStyles = (enabled: boolean): SxProps => ({
  fontWeight: YodaFontWeight.medium,
  fontSize: YodaFontSize.medium,
  color: enabled ? YodaColors.textPrimary : YodaColors.gray3,
});

export const reminderDescriptionStyles = (enabled: boolean): SxProps => ({
  fontSize: YodaFontSize.small,
  color: enabled ? YodaColors.textSecondary : YodaColors.gray3,
  marginTop: YodaSpacing.xxSmall,
});

export const sendTimeTextStyles: SxProps = {
  fontSize: YodaFontSize.small,
  color: YodaColors.textSecondary,
};

type MarketDefaultColorType = 'required' | 'onByDefault' | 'offByDefault';

export const getMarketDefaultColor = (status: MarketDefaultColorType): string => {
  switch (status) {
    case 'required':
      return YodaColors.blue7;
    case 'onByDefault':
      return YodaColors.green1;
    case 'offByDefault':
      return YodaColors.gray3;
    default:
      return YodaColors.textSecondary;
  }
};

export const marketDefaultBadgeStyles = (status: MarketDefaultColorType): SxProps => {
  const color = getMarketDefaultColor(status);
  return {
    display: 'inline-block',
    fontSize: YodaFontSize.xSmall,
    fontWeight: YodaFontWeight.medium,
    color,
    border: `1px solid ${color}`,
    borderRadius: '4px',
    padding: '4px 8px',
  };
};

export const headerContainerStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: YodaSpacing.medium,
};

export const marketInfoStyles: SxProps = {
  fontSize: YodaFontSize.small,
  color: YodaColors.blue7,
  fontWeight: YodaFontWeight.medium,
};

export const allRemindersLabelStyles: SxProps = {
  fontSize: YodaFontSize.medium,
  fontWeight: YodaFontWeight.medium,
  color: YodaColors.textPrimary,
};

export const buttonsContainerStyles: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: YodaSpacing.medium,
  marginTop: YodaSpacing.large,
};
